import { render, staticRenderFns } from "./openingSteps.vue?vue&type=template&id=f7b022d6&scoped=true"
import script from "./openingSteps.vue?vue&type=script&lang=js"
export * from "./openingSteps.vue?vue&type=script&lang=js"
import style0 from "./openingSteps.vue?vue&type=style&index=0&id=f7b022d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b022d6",
  null
  
)

export default component.exports